import { Component, OnInit } from '@angular/core';
import { AuthenService } from '@core/authen/authen.service';
import { SessionService } from '@core/session.service';
import { environment } from '@env/environment';
import { UrlParam } from '@shared/enums/url-param.enum';
import { FormUtils } from '@shared/utils/form-utils';
import { StringUtils } from '@shared/utils/string-utils';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
})
export class AuthenticationComponent implements OnInit {
  constructor(
    public authenService: AuthenService,
    public sessionService: SessionService
  ) {}

  ngOnInit(): void {
    const elementorPreview = StringUtils.getParamFromUrl(
      UrlParam.ElementorPreview
    );

    this.authenService.authenticated().subscribe(authenticated => {
      if (authenticated || elementorPreview) return;
      this.goToLogin();
    });
  }

  goToLogin(): void {
    this.sessionService.setLoginCallBackpage(location.href);
    FormUtils.navigateTo(
      this.sessionService.appendLanguagePath(environment.jipUrl.login)
    );
  }
}
